import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import qcareApi from "./qcareApi";
import { SingleReportResponse } from '../interfaces/intakes.reports';

interface UpdateDateProps {
    reportId: string,
    date: Date
}

const getSingleReport = async (id: string) => {
    const { data } = await qcareApi.get<SingleReportResponse>(`/report/${id}`);
    return data
};

const updateReportDate = async ({reportId, date}:UpdateDateProps) => {
    
    const {data} = await qcareApi.put(`/report/edit-date/${reportId}`, {
        date
    })
    return data
};

// ------------------------- HOOKS -------------------------

//OK
export const useReport = (id: string) => {
    return useQuery(
        ['report', id],
        () => getSingleReport(id),
        { select: (data) => { return data.singleReport } }
    );
}

export const useUpdateReportDate = () => {
    const queryClient = useQueryClient()
    return useMutation(updateReportDate, {
        onSuccess: async (data) => {
            await queryClient.invalidateQueries( ['report', data.reportId])
            await queryClient.invalidateQueries( ['reports'])
        }
    })
}